export const GA_EVENTS = {
  DEBUG_VIEW: 'debug_console_view',
  LOGS_VIEW: 'logs_console_view',
  OVERVIEW_VIEW: 'overview_view',
  DEVICE_SETTINGS_VIEW: 'device_settings_view',
  BILLING_VIEW: 'billing_usage_view',
}